import { useStaticQuery, graphql } from "gatsby";

const ProductQuery = () => {
  const { allSanityProduct } = useStaticQuery(graphql`
    query ProductQuery {
      allSanityProduct {
        nodes {
          id
          _id
          content {
            shopify {
              productId
            }
            info {
              declaredWeight
            }
          }
        }
      }
    }
  `);

  return allSanityProduct;
};

export default ProductQuery;
